import axios from "axios";

export const getAll = () => {
  return axios.get(`${process.env.VUE_APP_API_URL}/podcasts`);
};

export const create = payload => {
  return axios.post(`${process.env.VUE_APP_API_URL}/podcasts`, payload);
};

export const update = (id, payload) => {
  return axios.post(`${process.env.VUE_APP_API_URL}/podcasts/${id}?_method=PUT`, payload);
};

export const remove = id => {
  return axios.delete(`${process.env.VUE_APP_API_URL}/podcasts/${id}`);
};
export const preview = (id = null, payload, lang) => {
  return axios.post(`${process.env.VUE_APP_API_URL}/podcasts/preview`, payload, {
    params: { id, lang }
  });
};
